const LOCAL_SUBFLOW_STEP_ID_PREFIX = 'local_';
const MAX_STEP_ID_LENGTH = 20;

export function createLocalSubflowStepId(): string {
  const randomLength = MAX_STEP_ID_LENGTH - LOCAL_SUBFLOW_STEP_ID_PREFIX.length;
  const randomSuffix = crypto.randomUUID().replaceAll('-', '').slice(0, randomLength);

  return `${LOCAL_SUBFLOW_STEP_ID_PREFIX}${randomSuffix}`;
}
